import { useMemo } from 'react';

import {
    ConvertibleUnitPreferenceTypes,
    ConvertibleUnitPreferences,
    DEFAULT_UNITS,
    useDisplayPreferences,
} from '@/api/userAccount';
import { Units } from '@/common/convert';

export function usePreferredUnits(): ConvertibleUnitPreferences;
export function usePreferredUnits<Q extends ConvertibleUnitPreferenceTypes>(type: Q): ConvertibleUnitPreferences[Q];
export function usePreferredUnits(type?: ConvertibleUnitPreferenceTypes): ConvertibleUnitPreferences | Units {
    const { data: displayPreferences } = useDisplayPreferences();
    const prefs = useMemo(() => ({ ...DEFAULT_UNITS, ...displayPreferences }), [displayPreferences]);
    if (type) {
        return prefs[type];
    }
    return prefs;
}
